
const Footer = () => {
    return (
        <footer className="footer has-background-dark-black">
            <div className="content has-text-centered has-text-white">
                <p>
                    Copyright @ timcreated.me 2023 | <a href="https://github.com/TsWin/timcreated.me">This website is OpenSource</a>
                </p>
            </div>
        </footer>
    )
}

export default Footer;